import React from "react";
import editIcon from "../svg/edit.svg";
import deleteIcon from "../svg/delete.svg";

function Departments(props) {
  const offices = props.offices;
  return (
    <div className="h-[50%] flex flex-col gap-2 xl:h-full flex-1">
      <div className="flex items-center gap-2">
        <h3 className="text-sm font-semibold text-slate-600 uppercase tracking-wide">Departments</h3>
        {offices.length > 0 && (
          <span className="text-xs bg-emerald-100 text-emerald-700 font-semibold px-2 py-0.5 rounded-full">
            {offices.length}
          </span>
        )}
      </div>
      <div className="flex-1 h-auto bg-slate-50 border border-slate-200 overflow-y-auto rounded-xl">
        {offices.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-2 py-8">
            <svg className="h-10 w-10 opacity-40" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5" />
            </svg>
            <span className="text-sm">Select a college to view departments</span>
          </div>
        ) : (
          offices.map((val, key) => {
            return (
              <div
                className="flex flex-row items-center gap-1 p-2 mx-1 my-1 rounded-lg hover:bg-slate-100 transition-colors"
                key={key}
              >
                <div className="flex-1 w-auto flex flex-col">
                  <h4 className="font-bold text-base text-slate-800">{val.shortName}</h4>
                  <p className="text-sm text-slate-500">{val.name}</p>
                </div>
                <div className="flex flex-row gap-1 items-center">
                  <button
                    className="p-1.5 rounded-lg hover:bg-sky-100 transition-colors"
                    onClick={() => {
                      props.editDepartment(val.id);
                    }}
                    title="Edit department"
                  >
                    <img className="h-4 w-4" src={editIcon} alt="Edit" />
                  </button>
                  <button
                    className="p-1.5 rounded-lg hover:bg-red-100 transition-colors"
                    onClick={() => {
                      props.deleteDepartment(val.id);
                    }}
                    title="Delete department"
                  >
                    <img className="h-4 w-4" src={deleteIcon} alt="Delete" />
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
      <div>
        <button
          className="flex items-center gap-1.5 bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white text-sm font-semibold rounded-lg py-2 px-5 transition-colors shadow-sm"
          onClick={props.newDepartment}
        >
          <span className="text-lg leading-none">+</span> New Department
        </button>
      </div>
    </div>
  );
}

export default Departments;
